import { asyncLoad } from '@util'

const AsyncSystemBulletin = asyncLoad(() =>
  import('@components/LocalMerchant/SystemBulletin')
)

const AsyncDetail = asyncLoad(() =>
  import('@components/LocalMerchant/SystemBulletin/Detail')
)

export default {
  path: 'systemBulletin',
  indexRoute: {
    component: AsyncSystemBulletin
  },
  stat: '系统公告/首页',
  childRoutes: [
    {
      path: ':id',
      component: AsyncDetail,
      stat: '系统公告/公告详情'
    }
  ]
}
